var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _path8, _g3, _path9, _g4, _path10, _path11, _g5, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g7, _path28, _path29, _path30, _path31, _g8, _path32, _path33, _path34, _path35, _g9, _path36, _path37, _path38, _g10, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g11, _g12, _path56, _g13, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g14, _path74, _path75, _path76, _g15, _path77;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomePink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 30,
    viewBox: "0 0 63 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8133 25.1429C56.8133 25.8066 56.2758 26.3438 55.6117 26.3438C54.9476 26.3438 54.4102 25.8066 54.4102 25.1429C54.4102 24.4791 54.9476 23.9419 55.6117 23.9419C56.2758 23.9419 56.8133 24.4813 56.8133 25.1429Z",
    fill: "#5FAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5824 27.5451C57.246 27.5451 57.784 27.0074 57.784 26.3441C57.784 25.6809 57.246 25.1432 56.5824 25.1432C55.9188 25.1432 55.3809 25.6809 55.3809 26.3441C55.3809 27.0074 55.9188 27.5451 56.5824 27.5451Z",
    fill: "#5FAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4881 28.085C58.4881 28.7488 57.9506 29.286 57.2865 29.286C56.6224 29.286 56.085 28.7488 56.085 28.085C56.085 27.4213 56.6224 26.884 57.2865 26.884C57.9506 26.884 58.4881 27.4213 58.4881 28.085Z",
    fill: "#5FAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6892 28.5844C59.6892 29.2481 59.1518 29.7854 58.4877 29.7854C57.8236 29.7854 57.2861 29.2481 57.2861 28.5844C57.2861 27.9206 57.8236 27.3834 58.4877 27.3834C59.1518 27.3834 59.6892 27.9206 59.6892 28.5844Z",
    fill: "#5FAEAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7816 28.6554C58.4452 28.6554 58.9832 28.1177 58.9832 27.4544C58.9832 26.7911 58.4452 26.2534 57.7816 26.2534C57.118 26.2534 56.5801 26.7911 56.5801 27.4544C56.5801 28.1177 57.118 28.6554 57.7816 28.6554Z",
    fill: "#5FAEAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38355 25.7513H4.83496V28.9591H5.38355V25.7513Z",
    fill: "#9A633E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.37663 25.7513H5.20117V28.9591H5.37663V25.7513Z",
    fill: "#919497"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10824 26.932C6.5765 26.932 7.76676 24.2336 7.76676 20.905C7.76676 17.5763 6.5765 14.8779 5.10824 14.8779C3.63997 14.8779 2.44971 17.5763 2.44971 20.905C2.44971 24.2336 3.63997 26.932 5.10824 26.932Z",
    fill: "#5FAEAE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.43421 14.9492C6.12494 16.0459 6.68907 17.8218 6.68907 19.8286C6.68907 23.1584 5.26097 25.8556 4.03054 25.8556C3.90172 25.8556 3.77069 25.8245 3.63965 25.769C4.09051 26.5016 4.61467 26.9345 5.10773 26.9345C6.33816 26.9345 7.76625 24.2351 7.76625 20.9074C7.76625 17.8928 6.49585 15.3976 5.43421 14.9492Z",
    fill: "#919497"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0962 24.1199H9.1167V28.8949H10.0962V24.1199Z",
    fill: "#CD8453"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0966 24.1199H9.76123V28.8949H10.0966V24.1199Z",
    fill: "#919497"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60552 25.8311C11.8416 25.8311 13.6544 24.0192 13.6544 21.7842C13.6544 19.5492 11.8416 17.7373 9.60552 17.7373C7.36939 17.7373 5.55664 19.5492 5.55664 21.7842C5.55664 24.0192 7.36939 25.8311 9.60552 25.8311Z",
    fill: "#5FAEAE"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.889 18.441C12.3332 19.0915 12.593 19.8751 12.593 20.7209C12.593 22.9563 10.7807 24.7678 8.54414 24.7678C7.69794 24.7678 6.91171 24.508 6.26318 24.064C6.99167 25.1318 8.21766 25.8311 9.608 25.8311C11.8445 25.8311 13.6569 24.0197 13.6569 21.7842C13.6569 20.3968 12.955 19.1714 11.889 18.441Z",
    fill: "#919497"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2671 16.6387H27.4136V28.9591H55.2671V16.6387Z",
    fill: "#F8DCBB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4136 16.656H58.1277L51.2893 6.81738H27.4136V16.656Z",
    fill: "#E966AD"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M55.2671 16.5902H27.4136V17.6735H55.2671V16.5902Z",
    fill: "#919497"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.5696 16.656H27.4136V6.81738H27.8889L30.5696 16.656Z",
    fill: "#919497"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9733 20.0225H38.7051V28.9598H43.9733V20.0225Z",
    fill: "#E966AD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1872 25.6692H39.5093V28.3042H43.1872V25.6692Z",
    fill: "#E966AD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1872 20.6567H39.5093V23.2918H43.1872V20.6567Z",
    fill: "#E966AD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1872 23.92H39.5093V25.0411H43.1872V23.92Z",
    fill: "#E966AD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9979 20.0231H29.3394V25.0045H35.9979V20.0231Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6337 20.3362H29.7036V24.6894H35.6337V20.3362Z",
    fill: "#8CBDCF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8998 24.6889L34.7721 20.3357H33.0442L31.1719 24.6889H32.8998Z",
    fill: "#C6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.009 20.3363H31.3982L29.7036 24.2811V24.6895H30.1389L32.009 20.3363Z",
    fill: "#C6E6E6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3417 20.0225H46.6831V25.0039H53.3417V20.0225Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9774 20.3352H47.0474V24.6884H52.9774V20.3352Z",
    fill: "#8CBDCF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3832 24.689L52.2533 20.3358H50.5254L48.6553 24.689H50.3832Z",
    fill: "#C6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3528 20.3354H48.742L47.0474 24.2802V24.6887H47.4827L49.3528 20.3354Z",
    fill: "#C6E6E6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.067 27.7167C31.067 27.8654 30.9471 27.9853 30.7983 27.9853C30.6495 27.9853 30.5317 27.8654 30.5317 27.7167C30.5317 27.568 30.6517 27.4503 30.7983 27.4503C30.9449 27.4503 31.067 27.568 31.067 27.7167Z",
    fill: "#C6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1515 27.7587C31.3 27.7587 31.4203 27.6384 31.4203 27.49C31.4203 27.3417 31.3 27.2214 31.1515 27.2214C31.0031 27.2214 30.8828 27.3417 30.8828 27.49C30.8828 27.6384 31.0031 27.7587 31.1515 27.7587Z",
    fill: "#C6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4603 27.6365C31.4603 27.7853 31.3404 27.9051 31.1938 27.9051C31.045 27.9051 30.9272 27.7853 30.9272 27.6365C30.9272 27.4878 31.0472 27.3701 31.1938 27.3701C31.3404 27.3679 31.4603 27.4878 31.4603 27.6365Z",
    fill: "#C6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7887 27.5966C31.7887 27.7453 31.6688 27.863 31.5222 27.863C31.3756 27.863 31.2534 27.7431 31.2534 27.5966C31.2534 27.4479 31.3734 27.328 31.5222 27.328C31.671 27.328 31.7887 27.4479 31.7887 27.5966Z",
    fill: "#C6E6E6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M31.6822 27.3859C31.7177 27.4303 31.7377 27.4858 31.7377 27.5479C31.7377 27.6966 31.6178 27.8143 31.4712 27.8143C31.409 27.8143 31.3535 27.7921 31.3091 27.7588C31.3579 27.8232 31.4335 27.8631 31.5201 27.8631C31.6689 27.8631 31.7866 27.7433 31.7866 27.5968C31.7888 27.5102 31.7466 27.4347 31.6822 27.3859Z",
    fill: "#919497"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9108 28.0249C32.0593 28.0249 32.1796 27.9046 32.1796 27.7563C32.1796 27.6079 32.0593 27.4877 31.9108 27.4877C31.7624 27.4877 31.6421 27.6079 31.6421 27.7563C31.6421 27.9046 31.7624 28.0249 31.9108 28.0249Z",
    fill: "#C6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5797 27.6365C32.5797 27.7852 32.4598 27.9051 32.311 27.9051C32.1621 27.9051 32.0444 27.7852 32.0444 27.6365C32.0444 27.4878 32.1644 27.3701 32.311 27.3701C32.4575 27.3701 32.5797 27.4878 32.5797 27.6365Z",
    fill: "#C6E6E6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8058 27.7167C32.8058 27.8654 32.6858 27.9853 32.5392 27.9853C32.3927 27.9853 32.2705 27.8654 32.2705 27.7167C32.2705 27.568 32.3904 27.4503 32.5392 27.4503C32.6881 27.4503 32.8058 27.568 32.8058 27.7167Z",
    fill: "#C6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2413 27.7167C33.2413 27.8654 33.1214 27.9853 32.9748 27.9853C32.8282 27.9853 32.7061 27.8654 32.7061 27.7167C32.7061 27.568 32.826 27.4503 32.9748 27.4503C33.1236 27.4503 33.2413 27.568 33.2413 27.7167Z",
    fill: "#C6E6E6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32.6951 27.4979C32.7262 27.5423 32.7462 27.5956 32.7462 27.6533C32.7462 27.8021 32.6263 27.9219 32.4797 27.9219C32.4219 27.9219 32.3686 27.9019 32.3242 27.8709C32.3731 27.9375 32.4508 27.9819 32.5419 27.9819C32.6907 27.9819 32.8084 27.862 32.8084 27.7132C32.8062 27.6267 32.7618 27.5468 32.6951 27.4979Z",
    fill: "#919497"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2723 27.5433C33.2723 27.692 33.1524 27.8119 33.0058 27.8119C32.857 27.8119 32.7393 27.692 32.7393 27.5433C32.7393 27.3945 32.8592 27.2747 33.0058 27.2747C33.1524 27.2747 33.2723 27.3945 33.2723 27.5433Z",
    fill: "#C6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6481 27.7167C33.6481 27.8654 33.5281 27.9853 33.3815 27.9853C33.235 27.9853 33.1128 27.8654 33.1128 27.7167C33.1128 27.568 33.2327 27.4503 33.3815 27.4503C33.5303 27.4503 33.6481 27.568 33.6481 27.7167Z",
    fill: "#C6E6E6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9967 27.7167C33.9967 27.8654 33.8768 27.9853 33.7302 27.9853C33.5836 27.9853 33.4614 27.8654 33.4614 27.7167C33.4614 27.568 33.5814 27.4503 33.7302 27.4503C33.879 27.4503 33.9967 27.568 33.9967 27.7167Z",
    fill: "#C6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7302 27.8652C33.8786 27.8652 33.9989 27.745 33.9989 27.5966C33.9989 27.4483 33.8786 27.328 33.7302 27.328C33.5817 27.328 33.4614 27.4483 33.4614 27.5966C33.4614 27.745 33.5817 27.8652 33.7302 27.8652Z",
    fill: "#C6E6E6"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.8922 27.3859C33.9277 27.4303 33.9477 27.4858 33.9477 27.5479C33.9477 27.6966 33.8278 27.8165 33.6812 27.8165C33.619 27.8165 33.5635 27.7943 33.519 27.761C33.5679 27.8254 33.6434 27.8654 33.73 27.8654C33.8788 27.8654 33.9966 27.7455 33.9966 27.599C33.9966 27.5102 33.9544 27.4347 33.8922 27.3859Z",
    fill: "#919497"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0363 28.0519C34.1847 28.0519 34.3051 27.9316 34.3051 27.7832C34.3051 27.6349 34.1847 27.5146 34.0363 27.5146C33.8879 27.5146 33.7676 27.6349 33.7676 27.7832C33.7676 27.9316 33.8879 28.0519 34.0363 28.0519Z",
    fill: "#C6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6515 27.7167C34.6515 27.8654 34.5315 27.9853 34.385 27.9853C34.2384 27.9853 34.1162 27.8654 34.1162 27.7167C34.1162 27.568 34.2361 27.4503 34.385 27.4503C34.5338 27.4503 34.6515 27.568 34.6515 27.7167Z",
    fill: "#C6E6E6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2936 27.6898C35.2936 27.8385 35.1736 27.9584 35.0248 27.9584C34.876 27.9584 34.7583 27.8385 34.7583 27.6898C34.7583 27.541 34.8782 27.4234 35.0248 27.4234C35.1736 27.4212 35.2936 27.541 35.2936 27.6898Z",
    fill: "#C6E6E6"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.1955 27.4824C35.2266 27.5268 35.2444 27.5779 35.2444 27.6356C35.2444 27.7843 35.1245 27.9042 34.9779 27.9042C34.9135 27.9042 34.8557 27.8798 34.8091 27.842C34.8579 27.9109 34.9379 27.9575 35.029 27.9575C35.1778 27.9575 35.2977 27.8376 35.2977 27.6889C35.2933 27.6045 35.2555 27.5313 35.1955 27.4824Z",
    fill: "#919497"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3054 27.8652C34.4538 27.8652 34.5741 27.745 34.5741 27.5966C34.5741 27.4483 34.4538 27.328 34.3054 27.328C34.1569 27.328 34.0366 27.4483 34.0366 27.5966C34.0366 27.745 34.1569 27.8652 34.3054 27.8652Z",
    fill: "#C6E6E6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0272 27.7562C35.0272 27.905 34.9073 28.0249 34.7607 28.0249C34.6141 28.0249 34.4941 27.905 34.4941 27.7562C34.4941 27.6075 34.6141 27.4899 34.7607 27.4899C34.9073 27.4899 35.0272 27.6075 35.0272 27.7562Z",
    fill: "#C6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3208 27.501C34.3208 27.5521 34.2786 27.5943 34.2276 27.5943C34.1765 27.5943 34.1343 27.5521 34.1343 27.501C34.1343 27.45 34.1765 27.4078 34.2276 27.4078C34.2786 27.4056 34.3208 27.4478 34.3208 27.501Z",
    fill: "#FCEE21"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8028 27.6897C34.8028 27.7407 34.7606 27.7829 34.7095 27.7829C34.6584 27.7829 34.6162 27.7407 34.6162 27.6897C34.6162 27.6386 34.6584 27.5964 34.7095 27.5964C34.7606 27.5964 34.8028 27.6386 34.8028 27.6897Z",
    fill: "#93278F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1856 27.6986C34.1856 27.7497 34.1434 27.7918 34.0923 27.7918C34.0412 27.7918 33.999 27.7497 33.999 27.6986C33.999 27.6475 34.0412 27.6053 34.0923 27.6053C34.1434 27.6053 34.1856 27.6475 34.1856 27.6986Z",
    fill: "#FCEE21"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7789 27.4481C33.7789 27.4992 33.7367 27.5413 33.6856 27.5413C33.6345 27.5413 33.5923 27.4992 33.5923 27.4481C33.5923 27.397 33.6345 27.3549 33.6856 27.3549C33.7367 27.3549 33.7789 27.397 33.7789 27.4481Z",
    fill: "#93278F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3345 27.4634C33.3345 27.5144 33.2923 27.5566 33.2412 27.5566C33.1902 27.5566 33.1479 27.5144 33.1479 27.4634C33.1479 27.4123 33.1902 27.3701 33.2412 27.3701C33.2923 27.3701 33.3345 27.4123 33.3345 27.4634Z",
    fill: "#FCEE21"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0528 27.5968C33.0528 27.6478 33.0106 27.69 32.9595 27.69C32.9084 27.69 32.8662 27.6478 32.8662 27.5968C32.8662 27.5457 32.9084 27.5035 32.9595 27.5035C33.0128 27.5035 33.0528 27.5435 33.0528 27.5968Z",
    fill: "#93278F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8526 27.4899C32.8526 27.541 32.8104 27.5832 32.7593 27.5832C32.7082 27.5832 32.666 27.541 32.666 27.4899C32.666 27.4389 32.7082 27.3967 32.7593 27.3967C32.8104 27.3945 32.8526 27.4367 32.8526 27.4899Z",
    fill: "#93278F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M33.459 27.7164C33.459 27.7675 33.4168 27.8096 33.3657 27.8096C33.3147 27.8096 33.2725 27.7675 33.2725 27.7164C33.2725 27.6653 33.3147 27.6232 33.3657 27.6232C33.4168 27.6232 33.459 27.6653 33.459 27.7164Z",
    fill: "#93278F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3643 27.6632C32.3643 27.7142 32.3221 27.7564 32.271 27.7564C32.2199 27.7564 32.1777 27.7142 32.1777 27.6632C32.1777 27.6121 32.2199 27.5699 32.271 27.5699C32.3221 27.5699 32.3643 27.6121 32.3643 27.6632Z",
    fill: "#93278F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4195 27.4059C32.4195 27.4569 32.3773 27.4991 32.3262 27.4991C32.2751 27.4991 32.2329 27.4569 32.2329 27.4059C32.2329 27.3548 32.2751 27.3126 32.3262 27.3126C32.3773 27.3126 32.4195 27.3548 32.4195 27.4059Z",
    fill: "#FCEE21"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M31.691 27.4391C31.691 27.4901 31.6488 27.5323 31.5977 27.5323C31.5466 27.5323 31.5044 27.4901 31.5044 27.4391C31.5044 27.388 31.5466 27.3458 31.5977 27.3458C31.6488 27.3458 31.691 27.388 31.691 27.4391Z",
    fill: "#FCEE21"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2071 27.5013C31.2071 27.5524 31.1649 27.5945 31.1138 27.5945C31.0627 27.5945 31.0205 27.5524 31.0205 27.5013C31.0205 27.4503 31.0627 27.4081 31.1138 27.4081C31.1649 27.4081 31.2071 27.448 31.2071 27.5013Z",
    fill: "#FCEE21"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 27.6364C31.6133 27.6875 31.5711 27.7297 31.52 27.7297C31.469 27.7297 31.4268 27.6875 31.4268 27.6364C31.4268 27.5854 31.469 27.5432 31.52 27.5432C31.5711 27.5432 31.6133 27.5832 31.6133 27.6364Z",
    fill: "#FCEE21"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8736 27.6564C30.8736 27.7074 30.8314 27.7496 30.7803 27.7496C30.7292 27.7496 30.687 27.7074 30.687 27.6564C30.687 27.6053 30.7292 27.5631 30.7803 27.5631C30.8314 27.5631 30.8736 27.6053 30.8736 27.6564Z",
    fill: "#93278F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3092 28.9311H30.4363L30.1831 27.8212H35.5624L35.3092 28.9311Z",
    fill: "#E966AD"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.3425 27.821L35.0894 28.931H35.3092L35.5624 27.821H35.3425Z",
    fill: "#919497"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30.7806 17.6733H27.4136V28.9305H30.7806V17.6733Z",
    fill: "#919497"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7445 1.39844L12.0776 6.81722V28.9586H27.4136V6.81722L19.7445 1.39844Z",
    fill: "#FFF1D5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0776 7.16364V9.77424L20.0244 3.73611L27.4136 9.35024V7.16364L19.7445 1.74707L12.0776 7.16364Z",
    fill: "#919497"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99316 8.92845L9.38129 10.7532L19.7445 2.87699L30.1098 10.7532L31.498 8.92845L19.7445 0L7.99316 8.92845Z",
    fill: "#E966AD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99316 8.92845L9.38129 10.7532L19.7445 2.87699L30.1098 10.7532L31.498 8.92845L19.7445 0L7.99316 8.92845Z",
    fill: "#E966AD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3862 20.0211H14.7271V25.0026H24.3862V20.0211Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0109 20.3351H15.1025V24.6883H24.0109V20.3351Z",
    fill: "#8CBDCF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2987 24.6881L20.1688 20.3348H18.4431L16.5708 24.6881H18.2987Z",
    fill: "#C3EFEF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4079 20.3348H16.7972L15.1025 24.2796V24.6881H15.5379L17.4079 20.3348Z",
    fill: "#C3EFEF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M19.633 20.3351H19.4775V24.6883H19.633V20.3351Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3862 10.0759H14.7271V15.0574H24.3862V10.0759Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0109 10.3888H15.1025V14.742H24.0109V10.3888Z",
    fill: "#8CBDCF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2987 14.7417L20.1688 10.3884H18.4431L16.5708 14.7417H18.2987Z",
    fill: "#C3EFEF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4079 10.3888H16.7972L15.1025 14.3336V14.742H15.5379L17.4079 10.3888Z",
    fill: "#C3EFEF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.633 10.3888H19.4775V14.742H19.633V10.3888Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4149 28.5543C53.4149 29.0804 52.9885 29.5088 52.4599 29.5088C51.9335 29.5088 51.5049 29.0826 51.5049 28.5543C51.5049 28.0282 51.9313 27.5997 52.4599 27.5997C52.9885 27.5997 53.4149 28.0282 53.4149 28.5543Z",
    fill: "#5FAEAE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M54.37 27.9817C54.37 28.5078 53.9436 28.9362 53.415 28.9362C52.8886 28.9362 52.46 28.51 52.46 27.9817C52.46 27.4555 52.8864 27.0271 53.415 27.0271C53.9414 27.0293 54.37 27.4555 54.37 27.9817Z",
    fill: "#5FAEAE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9677 28.5543C54.9677 29.0804 54.5412 29.5088 54.0126 29.5088C53.4863 29.5088 53.0576 29.0826 53.0576 28.5543C53.0576 28.0282 53.484 27.5997 54.0126 27.5997C54.539 27.5997 54.9677 28.0282 54.9677 28.5543Z",
    fill: "#5FAEAE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5819 28.5543C56.5819 29.0804 56.1555 29.5088 55.6269 29.5088C55.1005 29.5088 54.6719 29.0826 54.6719 28.5543C54.6719 28.0282 55.0983 27.5997 55.6269 27.5997C56.1533 27.5997 56.5819 28.0282 56.5819 28.5543Z",
    fill: "#5FAEAE"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8583 27.296C55.8583 27.8221 55.4319 28.2506 54.9033 28.2506C54.3769 28.2506 53.9482 27.8243 53.9482 27.296C53.9482 26.7699 54.3747 26.3414 54.9033 26.3414C55.4319 26.3437 55.8583 26.7699 55.8583 27.296Z",
    fill: "#5FAEAE"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M54.481 27.5365C54.6187 27.7163 54.7031 27.9427 54.7031 28.1869C54.7031 28.7796 54.2211 29.2614 53.6281 29.2614C53.4105 29.2614 53.2083 29.197 53.0396 29.0838C53.235 29.3413 53.5437 29.5078 53.8924 29.5078C54.4854 29.5078 54.9674 29.026 54.9674 28.4333C54.9674 28.0582 54.7742 27.7274 54.481 27.5365Z",
    fill: "#919497"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0394 27.6308C57.0394 28.1569 56.613 28.5854 56.0844 28.5854C55.558 28.5854 55.1294 28.1592 55.1294 27.6308C55.1294 27.1047 55.5558 26.6763 56.0844 26.6763C56.613 26.6763 57.0394 27.1025 57.0394 27.6308Z",
    fill: "#5FAEAE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5351 28.936C57.5351 29.4621 57.1086 29.8906 56.58 29.8906C56.0537 29.8906 55.625 29.4643 55.625 28.936C55.625 28.4099 56.0514 27.9814 56.58 27.9814C57.1086 27.9814 57.5351 28.4099 57.5351 28.936Z",
    fill: "#5FAEAE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5819 26.583C56.5819 27.1091 56.1555 27.5375 55.6269 27.5375C55.1005 27.5375 54.6719 27.1113 54.6719 26.583C54.6719 26.0569 55.0983 25.6284 55.6269 25.6284C56.1533 25.6306 56.5819 26.0569 56.5819 26.583Z",
    fill: "#5FAEAE"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M56.9395 28.0527C57.0039 27.9262 57.0394 27.7819 57.0394 27.6287C57.0394 27.2735 56.844 26.9627 56.5553 26.7984C56.5708 26.7296 56.5819 26.6564 56.5819 26.5809C56.5819 26.0548 56.1555 25.6263 55.6269 25.6263C55.6224 25.6263 55.618 25.6263 55.6113 25.6263C55.8956 25.7906 56.0844 26.097 56.0844 26.4499C56.0844 26.5254 56.0755 26.5964 56.0577 26.6675C56.3465 26.8318 56.5419 27.1403 56.5419 27.4977C56.5419 27.6509 56.5064 27.793 56.442 27.9217C56.7907 28.0638 57.0372 28.4057 57.0372 28.8052C57.0372 29.3269 56.6197 29.7487 56.0999 29.7576C56.2399 29.8397 56.4042 29.8886 56.5775 29.8886C57.1038 29.8886 57.5325 29.4623 57.5325 28.934C57.5347 28.5366 57.2882 28.1948 56.9395 28.0527Z",
    fill: "#919497"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5632 28.9301H0V30H62.5632V28.9301Z",
    fill: "#5FAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePink);
export default __webpack_public_path__ + "static/media/homePink.2a3ce1a8a5b35efe0a9cf2b791410108.svg";
export { ForwardRef as ReactComponent };